module.exports = __webpack_public_path__ + "media/audio127.53607021.mp3";